module.exports = __webpack_public_path__ + "img/caixian1.f874bd34.png";